<div>
    <form [formGroup]="form">
        <div *ngFor="let item of configs" >
            <app-dynamic-form [config]="item" [form]="form"></app-dynamic-form>
        </div>
    </form>
</div>